import styled from "@emotion/styled";

import UIcon, { IconKey } from "../../../lib/icons/untitled_ui/UIcon";
import { Flex } from "../../../styles/utility-components";

type StageType = {
  label: string;
  color: string;
  iconColor: string;
  iconName: string;
};

/**
 * @deprecated Use {@link components/ui/form_components/StageSelect/Stage.tsx} instead.
 */
export function Stage({ label, iconName, color, iconColor }: StageType) {
  const icon = iconName as IconKey;

  return (
    <StageSelectTagContainer backgroundColor={color}>
      {iconName && <Icon icon={icon} color={iconColor}></Icon>}
      <LabelText title={label}>{label}</LabelText>
    </StageSelectTagContainer>
  );
}

const StageSelectTagContainer = styled(Flex)<{ backgroundColor: string }>(
  ({ backgroundColor, theme }) => ({
    display: "flex",
    alignItems: "center",
    color: theme.colors.sysTextDefault,
    gap: 8,
    width: "fit-content",
    minHeight: 26,
    padding: "2px 8px",
    backgroundColor,
    borderRadius: 2,
  }),
);

const Icon = styled(UIcon)({
  width: 12,
  height: 12,
  flexShrink: 0,
});

const LabelText = styled.span({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0, // Allow flex child to shrink below content size
});
